// extracted by mini-css-extract-plugin
export default {"label":"label_label__23u57"};